import CircularProgress from '@mui/material/CircularProgress'
import { AuthController } from 'features/onboard'
import isEmpty from 'lodash/isEmpty'
import { useEffect } from 'react'
// components
import { Route, type RouteComponentProps, withRouter } from 'react-router-dom'
import { appConnector } from 'shared/connector'

// actions
import { connectorAPI } from '../../actions/connector'
import { appActions, appSelectors } from '../../redux/reducers/app'
import { useActionCreators, useAppSelector } from '../../shared/hooks/index'

function LayoutUser({
	component: Component,
	...routerProps
}: RouteComponentProps & {
	archive?: boolean
	component: any
	exact?: boolean
	path?: string
}) {
	const isInstalled = useAppSelector(appSelectors.isInstalled)
	const linkedProfile = useAppSelector(appSelectors.linkedProfile)
	const appProfileDone = useAppSelector(appSelectors.appProfileDone)
	const auth = useAppSelector(appSelectors.auth)
	const connector = useAppSelector(appSelectors.connector)
	const isReadyConnector = useAppSelector(appSelectors.isReadyConnector)

	const path = routerProps.path

	const { setAssociatedLinkedInProfile } = useActionCreators(appActions)

	// biome-ignore lint/correctness/useExhaustiveDependencies: old code, not sure
	useEffect(() => {
		if (isReadyConnector) {
			connectorAPI.setUpInit()
		}
	}, [connector, auth])

	useEffect(() => {
		if (isInstalled && appProfileDone && !isEmpty(linkedProfile)) {
			checkIsAssociatedLinkedInProfile()
		}
	}, [isInstalled, appProfileDone, linkedProfile])

	const checkIsAssociatedLinkedInProfile = () => {
		const associatedLinkedInProfile =
			appConnector.auth.isSignedInUnderAssociatedLinkedInProfile()

		associatedLinkedInProfile.then((value: unknown) =>
			setAssociatedLinkedInProfile(Boolean(value))
		)
	}

	switch (auth) {
		case 'auth':
			return <Route path={path} render={() => <Component {...routerProps} />} />

		case 'none':
			return <Route component={AuthController} path={path} />

		default:
			return (
				<Route
					path={path}
					render={() => (
						<div className='material-loader-wrapper'>
							<CircularProgress
								classes={{ colorPrimary: 'material-loader' }}
								color='primary'
								size={60}
							/>
						</div>
					)}
				/>
			)
	}
}

export default withRouter(LayoutUser)
